import cx from 'classnames'
import React from 'react'

export function UnorderedList (props) {
  return (
    <ul
      {...props.attributes}
      className={cx(props.attributes.className, 'list-disc')}
      style={props.style}
    >
      {props.children}
    </ul>
  )
}
